import React, { useEffect, useRef, useState } from "react";
import { FaSearch, FaRedo } from "react-icons/fa";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import api from "../../services/api";
import Loading from "../../components/Loader/Loading";
import MUIDataTable from "../../components/MUIGrid";
import { toast } from "react-toastify";
import {
  GridToolbarColumnsButton,
  GridToolbarContainer,
  GridToolbarDensitySelector,
  GridToolbarFilterButton,
} from "@mui/x-data-grid-pro";
import { Button as MUIButton, TablePagination } from "@mui/material";
import CustomBreadcrumbs from "../../components/common/CustomBreadcrumbs";
import FullPagePopup from "./fullPagePopup";
import { Modal } from "../../components";
import { useNavigate } from "react-router-dom";
const DomainsReport = () => {
  const navigate = useNavigate();
  const [domainReport, setDomainReport] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [toggleStates, setToggleStates] = useState({});
  const [paginationModel, setPaginationModel] = React.useState({
    pageSize: 100,
    page: 1,
  });
  const [queryOptions, setQueryOptions] = React.useState({
    groupOp: "",
    rules: [],
  });

  const [sortingModel, setSortingModel] = React.useState({
    sortField: null,
    sortOrder: null,
  });
  const getDomainList = async (filter) => {
    setIsLoading(true);
    let payload = { ...filter };

    // Handle isworking field separately
    if (payload?.filters?.rules) {
      const isWorkingRuleIndex = payload.filters.rules.findIndex(
        (rule) => rule.field === "isWorking"
      );
      if (isWorkingRuleIndex !== -1) {
        const [isWorkingRule] = payload.filters.rules.splice(
          isWorkingRuleIndex,
          1
        );
        payload.isWorking = isWorkingRule.data;
      }

      // Remove filters if no rules left
      if (payload.filters.rules.length === 0) {
        delete payload.filters;
      }
    }

    delete payload?.pageSize;
    try {
      const res = await api.post("/api/domains", payload);
      if (res.status === 200) {
        setDomainReport(res.data);
      }
      setIsLoading(false);
    } catch (err) {
      setIsLoading(false);
      console.log(err);
    }
  };

  useEffect(() => {
    getDomainList({
      ...sortingModel,
      ...paginationModel,
      perPage: paginationModel.pageSize,
      filters: queryOptions,
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handlePageSizeChange = (newPageSize) => {
    setPaginationModel({ ...paginationModel, pageSize: newPageSize });
  };
  const handlePageChange = (params) => {
    setPaginationModel({ pageSize: params.pageSize, page: params.page + 1 });
    getDomainList({
      ...sortingModel,
      filters: queryOptions,
      page: +params.page + 1,
      size: params.pageSize,
    });
  };

  const processFilters = (filters) => {
    return (filters || [])?.map((filter) => {
      if (
        filter.operator === "isAnyOf" &&
        filter.value?.length &&
        filter.value[0]?.includes(",")
      ) {
        return {
          ...filter,
          value: filter.value[0].split(",").map((item) => item.trim()),
        };
      }
      return filter;
    });
  };

  const [idsArray, setIdsArray] = useState([]);
  const TagsCellRenderer = (data) => {
    const values = idsArray?.includes(data?.row?._id)
      ? data?.value
      : data?.value?.slice(0, 1);
    const tags = values?.map((tag, index) => (
      <span
        key={tag._id}
        style={{
          margin: "2px",
          color: "black",
          borderRadius: 2,
          padding: "0.2em 0.6em 0.3em",
          lineHeight: 1,
          whiteSpace: "nowrap",
          display: "inline-block",
        }}
      >
        {index + 1}. {tag}
      </span>
    ));

    return (
      <div className="flex flex-col">
        <div className="flex flex-col w-auto">{tags}</div>
        {data?.value?.length > 1 ? (
          !idsArray?.includes(data?.row?._id) ? (
            <div
              className="flex flex-col w-auto ml-3 text-[#1d4ed8] cursor-pointer hover:text-blue-700 focus:text-blue-700"
              onClick={() => setIdsArray([...idsArray, data?.row?._id])}
            >
              {`See More (${data?.value?.length - 1})`}
            </div>
          ) : (
            <div
              className="flex flex-col w-auto ml-3 text-[#1d4ed8] cursor-pointer hover:text-blue-700 focus:text-blue-700"
              onClick={() =>
                setIdsArray((preArray) => {
                  if (!preArray || !data?.row?._id) return preArray;
                  return preArray.filter((id) => id !== data.row._id);
                })
              }
            >
              {`See Less`}
            </div>
          )
        ) : null}
      </div>
    );
  };
  const columnDefs = [
    { headerName: "Sr#", field: "counter", width: 10, filterable: false },
    {
      headerName: "Domain",
      field: "d.domain",
      width: 250,
      renderCell: (params) => {
        return (
          <a
            href={`https://www.${params.row["d.domain"]}`}
            className="hover:text-secondary underline"
            target="_blank"
            rel="noreferrer"
          >
            {params.row["d.domain"]}
          </a>
        );
      },
    },
    {
      field: "d.is_money_plus",
      headerName: "Money Plus",
      width: 120,
      editable: false,
      type: "singleSelect",
      minWidth: 60,
      disableColumnMenu: true,
      align: "center",
      valueOptions: [
        { value: 1, label: "Yes" },
        { value: 0, label: "No" },
      ],
      getOptionValue: (option) => option?.value,
      getOptionLabel: (option) => option.label,
      renderCell: (params) => {
        const isChecked =
          toggleStates[params.row._id] !== undefined
            ? toggleStates[params.row._id]
            : params.row["d.is_money_plus"] === 1;
        return (
          <label className="flex items-center relative w-max cursor-pointer select-none ">
            <input
              type="checkbox"
              checked={isChecked}
              onChange={() => handleToggle(params)}
              className="appearance-none transition-colors cursor-pointer w-14 h-6 rounded-full focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-black focus:ring-blue-500 bg-gray-500 checked:bg-green-500"
            />
            <span className="absolute font-medium text-xxs uppercase right-1 text-white">
              No
            </span>
            <span className="absolute font-medium text-xxs uppercase right-8 text-white">
              Yes
            </span>
            <span
              className={`w-6 h-6 right-7 absolute rounded-full transform transition-transform bg-gray-200 ${
                isChecked ? "translate-x-7" : "translate-x-0"
              }`}
            />
          </label>
        );
      },
    },
    {
      headerName: "Total Tasks",
      field: "backlinks_count",
      type: "number",
      minWidth: 100,
      renderCell: (params) =>
        params?.row.backlinks_count > 0 ? (
          <button
            onClick={() =>
              openPopup(params?.row["d.id"], params.row["d.domain"])
            }
          >
            <span className="bg-[#93c5fd] py-1 px-2 !rounded hover:cursor-pointer ml-3">
              {params?.row.backlinks_count}
            </span>
          </button>
        ) : (
          <span className="bg-[#93c5fd] py-1 px-2 !rounded hover:cursor-pointer ml-3">
            0
          </span>
        ),
    },
    {
      field: "dd.total_pending",
      headerName: "Total Pending",
      minWidth: 120,
      editable: false,
      type: "number",
      renderCell: (params) =>
        params?.row["dd.total_pending"] > 0 ? (
          <span className="bg-[#93c5fd] py-1 px-2 !rounded hover:cursor-pointer ml-3">
            {params?.row["dd.total_pending"]}
          </span>
        ) : (
          <span className="bg-[#93c5fd] py-1 px-2 !rounded hover:cursor-pointer ml-3">
            0
          </span>
        ),
    },
    {
      field: "dd.total_inProcess",
      headerName: "Total In Process",
      minWidth: 130,
      editable: false,
      type: "number",
      renderCell: (params) =>
        params?.row["dd.total_inProcess"] > 0 ? (
          <span className="bg-[#93c5fd] py-1 px-2 !rounded hover:cursor-pointer ml-3">
            {params?.row["dd.total_inProcess"]}
          </span>
        ) : (
          <span className="bg-[#93c5fd] py-1 px-2 !rounded hover:cursor-pointer ml-3">
            0
          </span>
        ),
    },
    {
      field: "dd.total_completed",
      headerName: "Total In Completed",
      minWidth: 130,
      editable: false,
      type: "number",
      renderCell: (params) =>
        params?.row["dd.total_completed"] > 0 ? (
          <span className="bg-[#93c5fd] py-1 px-2 !rounded hover:cursor-pointer ml-3">
            {params?.row["dd.total_completed"]}
          </span>
        ) : (
          <span className="bg-[#93c5fd] py-1 px-2 !rounded hover:cursor-pointer ml-3">
            0
          </span>
        ),
    },
    {
      field: "dd.total_hold",
      headerName: "Total Hold",
      minWidth: 120,
      editable: false,
      type: "number",
      renderCell: (params) =>
        params?.row["dd.total_hold"] > 0 ? (
          <span className="bg-[#93c5fd] py-1 px-2 !rounded hover:cursor-pointer ml-3">
            {params?.row["dd.total_hold"]}
          </span>
        ) : (
          <span className="bg-[#93c5fd] py-1 px-2 !rounded hover:cursor-pointer ml-3">
            0
          </span>
        ),
    },
    {
      field: "dd.total_inReview",
      headerName: "Total In Review",
      minWidth: 120,
      editable: false,
      type: "number",
      renderCell: (params) =>
        params?.row["dd.total_inReview"] > 0 ? (
          <span className="bg-[#93c5fd] py-1 px-2 !rounded hover:cursor-pointer ml-3">
            {params?.row["dd.total_inReview"]}
          </span>
        ) : (
          <span className="bg-[#93c5fd] py-1 px-2 !rounded hover:cursor-pointer ml-3">
            0
          </span>
        ),
    },
    {
      field: "dd.total_cancelled",
      headerName: "Total Cancelled",
      minWidth: 120,
      editable: false,
      type: "number",
      renderCell: (params) =>
        params?.row["dd.total_cancelled"] > 0 ? (
          <span className="bg-[#93c5fd] py-1 px-2 !rounded hover:cursor-pointer ml-3">
            {params?.row["dd.total_cancelled"]}
          </span>
        ) : (
          <span className="bg-[#93c5fd] py-1 px-2 !rounded hover:cursor-pointer ml-3">
            0
          </span>
        ),
    },
    {
      headerName: "First Name",
      field: "d.fname",
      flex: 1,
      minWidth: 100,
    },
    {
      headerName: "Last Name",
      field: "d.lname",
      flex: 1,
      minWidth: 100,
    },
    {
      headerName: "Email",
      field: "d.email",
      flex: 1,
      minWidth: 100,
    },
    {
      headerName: "Phone",
      field: "d.phone",
      flex: 1,
      minWidth: 100,
    },
    {
      headerName: "Assigned Users",
      field: "dd.assigned_user_names",
      renderCell: TagsCellRenderer,
      flex: 1,
      minWidth: 200,
      sortable: false,
      filterable: false,
    },
    {
      headerName: "Industry",
      field: "i.industry_name",
      flex: 1,
      minWidth: 100,
    },
    {
      headerName: "State",
      field: "d.state",
      flex: 1,
      minWidth: 100,
    },
    {
      headerName: "City",
      field: "d.city",
      flex: 1,
      minWidth: 100,
    },
    {
      field: "isWorking",
      headerName: "Working",
      width: 120,
      editable: false,
      type: "singleSelect",
      minWidth: 60,
      disableColumnMenu: true,
      align: "center",
      valueOptions: [
        { value: "Yes", label: "Yes" },
        { value: "No", label: "No" },
      ],
      getOptionValue: (option) => option?.value,
      getOptionLabel: (option) => option.label,
    },
    {
      field: "generate_domain_blog",
      headerName: "Generate Domain Blog",
      width: 200,
      editable: false,
      minWidth: 60,
      disableColumnMenu: true,
      renderCell: (params) => {
        return (
          <span className="flex gap-2">
            <button
              className="bg-[#042A42] text-white btnPrimary py-1 px-2 !rounded hover:cursor-pointer ml-3"
              onClick={() =>
                navigate("/generateblog", {
                  state: {
                    city: params.row["d.city"],
                    domain: params.row["d.domain"],
                    industry: params.row["i.industry_name"],
                  },
                })
              }
            >
              Generate Blog
            </button>
            <button
              className="bg-[#042A42] text-white btnPrimary py-1 px-2 !rounded hover:cursor-pointer flex items-center gap-1"
              onClick={() => {
                removeBlogCache(params.row["d.domain"]);
              }}
            >
              <FaRedo size={12} />
            </button>
          </span>
        );
      },
    },
    {
      field: "generate_faq",
      headerName: "Generate Faq's",
      width: 200,
      editable: false,
      minWidth: 60,
      disableColumnMenu: true,
      renderCell: (params) => {
        return (
          <span className="flex gap-2">
            <button
              className="bg-[#042A42] text-white btnPrimary py-1 px-2 !rounded hover:cursor-pointer ml-3"
              onClick={() =>
                navigate("/generatefaq", {
                  state: {
                    city: params.row["d.city"],
                    domain: params.row["d.domain"],
                  },
                })
              }
            >
              Generate Faq's
            </button>
            <button
              className="bg-[#042A42] text-white btnPrimary py-1 px-2 !rounded hover:cursor-pointer flex items-center gap-1"
              onClick={() => {
                removeFaqsCache(params.row["d.domain"]);
              }}
            >
              <FaRedo size={12} />
            </button>
          </span>
        );
      },
    },

    {
      field: "generate_content",
      headerName: "Generate Content",
      width: 200,
      editable: false,
      minWidth: 60,
      disableColumnMenu: true,
      renderCell: (params) => {
        return (
          <span className="flex gap-2">
            <button
              className="bg-[#042A42] text-white btnPrimary py-1 px-2 !rounded hover:cursor-pointer ml-3"
              onClick={() =>
                navigate("/generatecontent", {
                  state: {
                    city: params.row["d.city"],
                    domain: params.row["d.domain"],
                  },
                })
              }
            >
              Generate Content
            </button>
            <button
              className="bg-[#042A42] text-white btnPrimary py-1 px-2 !rounded hover:cursor-pointer flex items-center gap-1"
              onClick={() => {
                removeContentCache(params.row["d.domain"]);
              }}
            >
              <FaRedo size={12} />
            </button>
          </span>
        );
      },
    },
  ];
  const operator = ({ operator, field }) => {
    const isSelect =
      columnDefs?.find((item) => item.field === field)?.type === "singleSelect";
    const isNumber =
      columnDefs?.find((item) => item.field === field)?.type === "number";
    const isDate =
      columnDefs?.find((item) => item.field === field)?.type === "date";
    return operator === "cn"
      ? "contains"
      : operator === "eq" && !isSelect && !isNumber
      ? "equals"
      : operator === "eq" && isSelect && !isNumber
      ? "is"
      : operator === "eq" && !isSelect && isNumber
      ? "="
      : operator === "not" && !isSelect && isNumber
      ? "!="
      : operator === "gt" && isDate
      ? "after"
      : operator === "gte" && isDate
      ? "onOrAfter"
      : operator === "lt" && isDate
      ? "before"
      : operator === "lte" && isDate
      ? "onOrBefore"
      : operator === "gt"
      ? ">"
      : operator === "gte"
      ? ">="
      : operator === "lt"
      ? "<"
      : operator === "lte"
      ? "<="
      : operator;
  };

  const [filterModel, setFilterModel] = React.useState({
    items: queryOptions.rules?.map(({ field, op, data }) => ({
      field,
      operator: operator({ operator: op, field }),
      value: data,
    })),
    logicOperator: "and",
    quickFilterValues: [],
    quickFilterLogicOperator: "and",
  });

  const onFilterChange = React.useCallback((filterModel) => {
    const item = processFilters(filterModel?.items || []);
    setFilterModel({
      ...filterModel,
      items: item,
    });
    let ruless = [];
    if (filterModel?.items?.length === 0) {
      getDomainList({
        ...sortingModel,
        page: 1,
        size: paginationModel.pageSize,
      });
    }
    // eslint-disable-next-line array-callback-return
    processFilters(filterModel?.items)?.map((rule) => {
      ruless = [
        ...ruless,
        {
          field: `${rule.field}`,
          op:
            rule.operator === "contains"
              ? "cn"
              : rule.operator === "equals"
              ? "eq"
              : rule.operator === "is"
              ? "eq"
              : rule.operator === "="
              ? "eq"
              : rule.operator === "!="
              ? "not"
              : rule.operator === ">"
              ? "gt"
              : rule.operator === ">="
              ? "gte"
              : rule.operator === "<"
              ? "lt"
              : rule.operator === "<="
              ? "lte"
              : rule.operator === "onOrBefore"
              ? "lte"
              : rule.operator === "before"
              ? "lt"
              : rule.operator === "onOrAfter"
              ? "gte"
              : rule.operator === "after"
              ? "gt"
              : rule.operator,
          data: rule.value
            ? rule.value
            : rule.value === 0
            ? rule.value
            : rule.value === false
            ? rule.value
            : null,
        },
      ];
    });
    setQueryOptions({
      groupOp: filterModel?.logicOperator?.toUpperCase() || "AND",
      rules: ruless,
    });
    // eslint-disable-next-line
  }, []);

  const handleNewFilter = () => {
    setPaginationModel({ pageSize: paginationModel.pageSize, page: 1 });
    getDomainList({
      ...sortingModel,
      filters: queryOptions,
      page: 1,
      size: paginationModel.pageSize,
    });
  };
  const handleTopPageChange = (page) => {
    setPaginationModel({ pageSize: paginationModel.pageSize, page: +page + 1 });
    getDomainList({
      ...sortingModel,
      filters: queryOptions,
      page: +page + 1,
      perPage: paginationModel.pageSize,
    });
  };
  const handleTopPageSizeChange = (newPageSize) => {
    setPaginationModel({ page: 1, pageSize: newPageSize });
    getDomainList({
      ...sortingModel,
      filters: queryOptions,
      page: 1,
      perPage: newPageSize,
    });
  };

  const handleSortModelChange = (params) => {
    setSortingModel({
      sortField: params[0]?.field,
      sortOrder: params[0]?.sort ? params[0]?.sort.toUpperCase() : "default",
    });

    getDomainList({
      filters: queryOptions,
      page: 1,
      perPage: paginationModel.pageSize,
      sortField: params[0]?.field,
      sortOrder: params[0]?.sort ? params[0]?.sort.toUpperCase() : "default",
    });
  };
  function CustomToolbar({ setFilterButtonEl }) {
    return (
      <GridToolbarContainer className="flex items-center justify-between">
        <div className="flex">
          <GridToolbarColumnsButton
            sx={{
              borderRadius: "6px",
              marginRight: "4px",
              border: "1px solid",
              borderColor: "#e8eaee",
              height: "26px",
              paddingLeft: 1,
              paddingRight: 1,
            }}
          />
          <GridToolbarDensitySelector
            sx={{
              borderRadius: "6px",
              marginRight: "4px",
              border: "1px solid",
              borderColor: "#e8eaee",
              height: "26px",
              paddingLeft: 1,
              paddingRight: 1,
            }}
          />
          <GridToolbarFilterButton
            sx={{
              borderRadius: "6px",
              marginRight: "4px",
              border: "1px solid",
              borderColor: "#e8eaee",
              height: "26px",
              paddingLeft: 1,
              paddingRight: 1,
            }}
            ref={setFilterButtonEl}
          />
          <MUIButton
            variant="text"
            onClick={handleNewFilter}
            startIcon={<FaSearch size={16} />}
            sx={{
              borderRadius: "6px",
              marginRight: "4px",
              border: "1px solid",
              borderColor: "#e8eaee",
              height: "26px",
              paddingLeft: 1,
              paddingRight: 1,
            }}
          >
            Apply filter
          </MUIButton>
        </div>
        <div className="flex items-center">
          <TablePagination
            color="primary"
            shape="rounded"
            size="medium"
            showFirstButton
            showLastButton
            count={
              domainReport?.count
                ? domainReport?.count
                : domainReport?.domainListData?.length || 0
            }
            page={paginationModel.page - 1 || 0}
            onPageChange={(e, page) => handleTopPageChange(page)}
            rowsPerPage={paginationModel.pageSize || 100}
            onRowsPerPageChange={(e) => handleTopPageSizeChange(e.target.value)}
            component="div"
            rowsPerPageOptions={[
              25,
              50,
              75,
              100,
              250,
              500,
              1000,
              1500,
              2000,
              {
                label: "All",
                value: domainReport?.count
                  ? domainReport?.count
                  : domainReport?.domainListData?.length || 0,
              },
            ]}
          />
        </div>
      </GridToolbarContainer>
    );
  }

  const dataRows = (domainReport?.domainListData || [])?.map(
    (record, index) => {
      const counter = index + 1;
      const records = record;
      const {
        "d.id": id,
        "d.domain": backlink_domain,
        backlinks_count,
        "d.fname": fname,
        "d.lname": lname,
        "d.email": email,
        "d.phone": phone,
        "i.industry_name": industry_name,
        "d.state": state,
        "d.city": city,
        "d.created_at": created_at,
        "dd.total_pending": total_pending,
        "dd.total_inProcess": total_inProcess,
        "dd.total_completed": total_completed,
        "dd.total_hold": total_hold,
        "dd.total_inReview": total_inReview,
        "dd.total_cancelled": total_cancelled,
        "dd.assigned_user_names": assigned_user_names,
        "d.is_money_plus": is_money_plus,
      } = record;
      const detailsArray = assigned_user_names
        ?.split(",")
        .map((detail) => detail.trim());
      return {
        counter,
        records,
        _id: id,
        "d.id": id,
        "d.domain": backlink_domain,
        backlinks_count,
        "d.fname": fname || "",
        "d.lname": lname,
        "d.email": email,
        "d.phone": phone,
        "i.industry_name": industry_name || "",
        "d.state": state || "",
        "d.city": city,
        "d.created_at": created_at,
        "dd.total_pending": total_pending,
        "dd.total_inProcess": total_inProcess,
        "dd.total_completed": total_completed,
        "dd.total_hold": total_hold,
        "dd.total_inReview": total_inReview,
        "dd.total_cancelled": total_cancelled,
        "dd.assigned_user_names": detailsArray,
        "d.is_money_plus": is_money_plus,
      };
    }
  );

  const [showPopup, setShowPopup] = useState(false); // State to control the popup visibility
  const showPopupRef = useRef(null);
  const [selectBackLinks, setSelectBackLinks] = useState("");
  const [backlinksData, setBacklinksData] = useState([]);
  const openPopup = (id, domain) => {
    setIsLoading(true);
    setSelectBackLinks(domain);
    api
      .post(
        `${process.env.REACT_APP_PUBLIC_API}/api/linkbuilder_user/task_info/${id}`,
        {}
      )
      .then((response) => {
        setBacklinksData(response?.data);
        setIsLoading(false);
        setShowPopup(true);
      })
      .catch((error) => {
        setIsLoading(false);
        console.log(error);
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  const closePopup = () => {
    setShowPopup(!showPopup);
  };

  const [columnVisibilityModel, setColumnVisibilityModel] = useState({
    "d.fname": false,
    "d.lname": false,
    "d.email": false,
    "d.phone": false,
    "d.state": false,
    "d.city": false,
    isWorking: false,
  });
  const handleColumnVisibilityChange = (model) => {
    setColumnVisibilityModel(model);
  };

  const getRowHeight = (params) => {
    const rowHeight = 40;
    const cellContentHeight = 0;
    const data = params?.model;
    const items = data["dd.assigned_user_names"] || [];

    const numberOfLines = items.length || 0;
    const addressHeight = rowHeight + numberOfLines * 20;

    if (items.length > 1) {
      if (!idsArray?.includes(data?._id)) {
        return rowHeight + 15;
      }

      const tagHeight = 25;
      const numTags = items.length;

      if (addressHeight > rowHeight + tagHeight * numTags + cellContentHeight) {
        return addressHeight;
      } else {
        return rowHeight + tagHeight * numTags + cellContentHeight;
      }
    }

    if (addressHeight > rowHeight + cellContentHeight) {
      return addressHeight;
    }

    return rowHeight + cellContentHeight;
  };

  const handleToggle = (params) => {
    setToggleStates((prev) => {
      const currentState =
        prev[params?.row?._id] !== undefined
          ? prev[params?.row?._id]
          : params?.row?.["d.is_money_plus"] === 1;
      const newState = !currentState;
      moneyPlusUpdate(newState, params?.row?.["d.domain"]);
      return {
        ...prev,
        [params?.row?._id]: newState,
      };
    });
  };

  const moneyPlusUpdate = async (newState, domain) => {
    setIsLoading(true);
    try {
      const res = await api.put(`/api/domains/is_money_plus`, {
        domain: domain,
        is_money_plus: newState ? 1 : 0,
      });
      if (res.status === 200 || res.status === 201) {
        toast.success("Money Plus Status Changed.");
      }
    } catch (err) {
      toast.error(err?.response?.data?.message);
    }
    setIsLoading(false);
  };
  const removeBlogCache = async (domain) => {
    setIsLoading(true);
    try {
      const res = await api.post(`https://www.${domain}/api/clear_blog_cache`, {
        domain: domain,
      });
      if (res.status === 200 || res.status === 201) {
        toast.success(
          res?.data?.message || "Blog cache cleared successfully..."
        );
      }
    } catch (err) {
      toast.error(
        err?.response?.data?.message || "Blog cache cleared failed..."
      );
    }
    setIsLoading(false);
  };
  const removeFaqsCache = async (domain) => {
    setIsLoading(true);
    try {
      const res = await api.post(`https://www.${domain}/api/clear_faqs_cache`, {
        domain: domain,
      });
      if (res.status === 200 || res.status === 201) {
        toast.success(
          res?.data?.message || "FAQs cache cleared successfully..."
        );
      }
    } catch (err) {
      toast.error(
        err?.response?.data?.message || "FAQs cache cleared failed..."
      );
    }
    setIsLoading(false);
  };
  const removeContentCache = async (domain) => {
    setIsLoading(true);
    try {
      const res = await api.post(
        `https://www.${domain}/api/clear_content_cache`,
        {
          domain: domain,
        }
      );
      if (res.status === 200 || res.status === 201) {
        toast.success(
          res?.data?.message || "Content cache cleared successfully..."
        );
      }
    } catch (err) {
      toast.error(
        err?.response?.data?.message || "Content cache cleared failed..."
      );
    }
    setIsLoading(false);
  };
  return (
    <div className="px-6 pt-4">
      <CustomBreadcrumbs
        crumbs={[
          { label: "Home", link: "/" },
          { label: "Domains", link: "" },
        ]}
      />
      <ToastContainer />
      {isLoading && <Loading />}
      <div className="bg-white my-3 border rounded">
        <MUIDataTable
          columnDefs={columnDefs}
          items={dataRows}
          totalItems={domainReport?.count}
          paginationModel={paginationModel}
          CustomToolbar={CustomToolbar}
          height="88vh"
          searchable="No"
          showCount="No"
          onPaginationModelChange={handlePageChange}
          onPageSizeChange={handlePageSizeChange}
          onFilterModelChange={onFilterChange}
          columnVisibilityModel={columnVisibilityModel}
          onColumnVisibilityModelChange={handleColumnVisibilityChange}
          gridOptions={getRowHeight}
          sortingMode="server"
          onSortModelChange={handleSortModelChange}
          filterModel={filterModel}
        />
      </div>
      <Modal
        open={!showPopup}
        handleModal={closePopup}
        cancelButtonRef={showPopupRef}
        className="max-w-6xl"
        title={`Total Tasks - ${selectBackLinks}`}
      >
        <FullPagePopup backlinksData={backlinksData} />
      </Modal>
    </div>
  );
};

export default DomainsReport;
